'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/~/react/react.js
// module id = 296
// module chunks = 0